<avatar [avatarUrl]="imgSrc" [plugEnabled]="plugEnabled" [title]="title" (loaded)="loadedPassThrough($event)"></avatar>
